//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

export const NO_INFORMATION_PROVIDED = 'No information provided';
